import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Copy, ExternalLink, Film, Video, Youtube } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";
import { Link } from "react-router-dom";

const MeusCanais = () => {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopied(text);
    toast.success("Link copiado para a área de transferência!");
    setTimeout(() => setCopied(null), 2000);
  };

  const canaisRumble = [
    {
      nome: "Corte Certo",
      link: "https://rumble.com/c/c-7706553",
      descricao: "Os melhores cortes e recortes de vídeos selecionados",
      interno: "/corte-certo"
    },
    {
      nome: "Palavra Viva Online",
      link: "https://rumble.com/c/c-7697051",
      descricao: "Mensagens e reflexões para alimentar sua fé",
      interno: "/palavra-viva"
    },
    {
      nome: "Canal de Oração - Salmos",
      link: "https://rumble.com/c/c-3001464",
      descricao: "Momentos de reflexão e oração através dos Salmos",
      interno: "/canal-oracao"
    },
    {
      nome: "Sussurros da Meia Noite",
      link: "https://rumble.com/c/c-7689103",
      descricao: "Histórias de terror e mistério",
      interno: "/rumble"
    },
    {
      nome: "Planeta Selvagem 6",
      link: "https://rumble.com/c/planetaselvagem6",
      descricao: "Vídeos sobre animais e natureza",
      interno: "/planeta-terra-chamando"
    }
  ];

  const canaisYoutube = [
    {
      nome: "Trilhos e Trem",
      link: "https://studio.youtube.com/channel/UCjRjVRJpkKHIrtnBPFS2bfQ",
      descricao: "Conteúdo sobre trens, ferrovias e curiosidades",
      interno: "/trilhos-trem"
    },
    {
      nome: "Tropa do Humor",
      link: "https://studio.youtube.com/channel/UC-20RsfqftBP6yKfOUHEdsA",
      descricao: "Vídeos de humor e entretenimento",
      interno: "/videos-engracados"
    },
    {
      nome: "Sonic Sprount",
      link: "https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig",
      descricao: "Canal de música e entretenimento",
      interno: "/sonic-sprount"
    },
    {
      nome: "CraftyCreations",
      link: "https://www.youtube.com/channel/UCYfW1FfL2OZk5u9-GakVKJg",
      descricao: "Vídeos sobre animais e vida selvagem",
      interno: "/crafty-creations"
    },
    {
      nome: "Planeta Terra Chamando",
      link: "https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w",
      descricao: "Documentários sobre natureza e planeta",
      interno: "/planeta-terra-chamando"
    }
  ];

  const videosDestaque = [
    {
      titulo: "O que aconteceu antes da criação do mundo? Jesus explicou #memesgospel",
      link: "https://rumble.com/v6u23mj-o-que-aconteceu-antes-da-criao-do-mundo-jesus-explicou-memesgospel.html",
      thumbnail: "https://sp.rmbl.ws/s8/6/g/h/5/x/gh5xg.OvCc.1.jpg",
      canal: "Palavra Viva Online",
      plataforma: "Rumble"
    },
    {
      titulo: "NOS TRILHOS DO SENHOR COMPLETAO.mp4",
      link: "https://rumble.com/v6sl2ud-nos-trilhos-do-senhor-completao.mp4.html?e9s=src_v1_ucp",
      thumbnail: "https://sp.rmbl.ws/s8/6/S/U/q/i/SUqii.OvCc.jpg",
      canal: "Canal de Oração",
      plataforma: "Rumble"
    },
    {
      titulo: "Tudo entreguei ao senhor",
      link: "https://www.youtube.com/watch?v=9nfiZe2-f0c",
      thumbnail: "https://i.ytimg.com/vi/9nfiZe2-f0c/hqdefault.jpg",
      canal: "Trilhos e Trem",
      plataforma: "YouTube"
    },
    {
      titulo: "CANAL DE GATOS NO RUMBLE 1",
      link: "https://www.youtube.com/watch?v=sj9vd83Q5V8",
      thumbnail: "https://i.ytimg.com/vi/sj9vd83Q5V8/hqdefault.jpg",
      canal: "Sonic Sprount",
      plataforma: "YouTube"
    },
    {
      titulo: "Peixes Coloridos",
      link: "https://www.youtube.com/shorts/j1f2FZezNF4",
      thumbnail: "https://i.ytimg.com/vi/j1f2FZezNF4/hqdefault.jpg",
      canal: "CraftyCreations",
      plataforma: "YouTube"
    },
    {
      titulo: "Reino Animal - Episódio 1",
      link: "https://www.youtube.com/watch?v=vC1R75jV9JA",
      thumbnail: "https://i.ytimg.com/vi/vC1R75jV9JA/hqdefault.jpg",
      canal: "Planeta Terra Chamando",
      plataforma: "YouTube"
    },
    {
      titulo: "Planeta Selvagem 2",
      link: "https://www.youtube.com/watch?v=Kw4HN5AJt60",
      thumbnail: "https://i.ytimg.com/vi/Kw4HN5AJt60/hqdefault.jpg",
      canal: "Planeta Terra Chamando",
      plataforma: "YouTube"
    },
    {
      titulo: "Criando canal musical",
      link: "https://www.youtube.com/watch?v=UGdGoSbg9d8",
      thumbnail: "https://i.ytimg.com/vi/UGdGoSbg9d8/hqdefault.jpg",
      canal: "Sonic Sprount",
      plataforma: "YouTube"
    },
    {
      titulo: "Banner para YouTube de música de jazz",
      link: "https://www.youtube.com/watch?v=pIxgVSURhz0",
      thumbnail: "https://i.ytimg.com/vi/pIxgVSURhz0/hqdefault.jpg",
      canal: "Sonic Sprount",
      plataforma: "YouTube"
    }
  ];

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent py-2">
            Meus Canais
          </h1>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
            Conheça e acompanhe todos os meus canais no Rumble e YouTube.
          </p>
        </div>

        <Tabs defaultValue="rumble" className="w-full mb-12">
          <div className="flex justify-center mb-8">
            <TabsList>
              <TabsTrigger value="rumble">Rumble</TabsTrigger>
              <TabsTrigger value="youtube">YouTube</TabsTrigger>
              <TabsTrigger value="destaques">Vídeos em Destaque</TabsTrigger>
            </TabsList>
          </div>
          
          <TabsContent value="rumble" className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {canaisRumble.map((canal, index) => (
                <Card key={index} className="overflow-hidden border border-border h-full">
                  <CardHeader className="bg-muted/50">
                    <CardTitle className="text-xl flex items-center">
                      <Film className="mr-2 h-5 w-5 text-primary" /> {canal.nome}
                    </CardTitle>
                    <CardDescription>{canal.descricao}</CardDescription>
                  </CardHeader>
                  <CardContent className="pt-6">
                    <p className="text-muted-foreground mb-4">
                      Acesse o canal {canal.nome} no Rumble para conferir todos os vídeos e conteúdos disponíveis.
                    </p>
                  </CardContent>
                  <CardFooter className="flex gap-2 flex-wrap">
                    <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground">
                      <a 
                        href={canal.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        <ExternalLink size={16} className="mr-1" /> Visitar no Rumble
                      </a>
                    </Button>
                    <Button asChild variant="outline">
                      <Link to={canal.interno}>
                        <Film size={16} className="mr-1" /> Ver Detalhes
                      </Link>
                    </Button>
                    <Button 
                      variant="ghost" 
                      onClick={() => handleCopy(canal.link)}
                      className={copied === canal.link ? "bg-primary/10" : ""}
                    >
                      <Copy size={16} className="mr-1" /> 
                      {copied === canal.link ? "Copiado!" : "Copiar Link"}
                    </Button>
                  </CardFooter>
                </Card>
              ))}
            </div>
            
            <div className="text-center mt-8">
              <Button 
                asChild 
                size="lg"
                className="bg-primary hover:bg-primary/90 text-primary-foreground"
              >
                <a 
                  href="https://rumble.com/register/FARIAS/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Criar Conta no Rumble
                </a>
              </Button>
              <p className="text-sm text-muted-foreground mt-2">
                Use meu link de referência para criar sua conta no Rumble
              </p>
            </div>
          </TabsContent>
          
          <TabsContent value="youtube" className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {canaisYoutube.map((canal, index) => (
                <Card key={index} className="overflow-hidden border border-border h-full">
                  <CardHeader className="bg-muted/50">
                    <CardTitle className="text-xl flex items-center">
                      <Youtube className="mr-2 h-5 w-5 text-primary" /> {canal.nome}
                    </CardTitle>
                    <CardDescription>{canal.descricao}</CardDescription>
                  </CardHeader>
                  <CardContent className="pt-6">
                    <p className="text-muted-foreground mb-4">
                      Acesse o canal {canal.nome} no YouTube para conferir todos os vídeos e conteúdos disponíveis.
                    </p>
                  </CardContent>
                  <CardFooter className="flex gap-2 flex-wrap">
                    <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground">
                      <a 
                        href={canal.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        <ExternalLink size={16} className="mr-1" /> Visitar no YouTube
                      </a>
                    </Button>
                    <Button asChild variant="outline">
                      <Link to={canal.interno}>
                        <Video size={16} className="mr-1" /> Ver Detalhes
                      </Link>
                    </Button>
                    <Button 
                      variant="ghost" 
                      onClick={() => handleCopy(canal.link)}
                      className={copied === canal.link ? "bg-primary/10" : ""}
                    >
                      <Copy size={16} className="mr-1" /> 
                      {copied === canal.link ? "Copiado!" : "Copiar Link"}
                    </Button>
                  </CardFooter>
                </Card>
              ))}
            </div>
            
            <Card className="border border-border mt-8">
              <CardHeader className="bg-muted/50">
                <CardTitle>Outros Canais no YouTube</CardTitle>
                <CardDescription>
                  Confira meus outros canais temáticos no YouTube
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  <div className="bg-card p-4 rounded-lg border border-border">
                    <h3 className="text-lg font-medium mb-1 flex items-center">
                      <Youtube size={16} className="mr-1 text-primary" /> Planeta Selvagem 2
                    </h3>
                    <a 
                      href="https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-sm text-primary hover:underline"
                    >
                      Visitar Canal
                    </a>
                  </div>
                  <div className="bg-card p-4 rounded-lg border border-border">
                    <h3 className="text-lg font-medium mb-1 flex items-center">
                      <Youtube size={16} className="mr-1 text-primary" /> Mundo da Música
                    </h3>
                    <a 
                      href="https://studio.youtube.com/channel/UCVvCouJz1bgUvppoKywZY3w" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-sm text-primary hover:underline"
                    >
                      Visitar Canal
                    </a>
                  </div>
                  <div className="bg-card p-4 rounded-lg border border-border">
                    <h3 className="text-lg font-medium mb-1 flex items-center">
                      <Youtube size={16} className="mr-1 text-primary" /> Hulk Star
                    </h3>
                    <a 
                      href="https://studio.youtube.com/channel/UC3OZQzlF-lDaXIxXpfjwKYQ" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-sm text-primary hover:underline"
                    >
                      Visitar Canal
                    </a>
                  </div>
                  <div className="bg-card p-4 rounded-lg border border-border">
                    <h3 className="text-lg font-medium mb-1 flex items-center">
                      <Youtube size={16} className="mr-1 text-primary" /> Desenhos Animados da TV
                    </h3>
                    <a 
                      href="https://studio.youtube.com/channel/UCGajLCMSud7T3P0Qvtee8bw" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-sm text-primary hover:underline"
                    >
                      Visitar Canal
                    </a>
                  </div>
                  <div className="bg-card p-4 rounded-lg border border-border">
                    <h3 className="text-lg font-medium mb-1 flex items-center">
                      <Youtube size={16} className="mr-1 text-primary" /> Rock Gametrons
                    </h3>
                    <a 
                      href="https://studio.youtube.com/channel/UCekE2SMNXqQDZWq5dpzDq6A" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-sm text-primary hover:underline"
                    >
                      Visitar Canal
                    </a>
                  </div>
                  <div className="bg-card p-4 rounded-lg border border-border">
                    <h3 className="text-lg font-medium mb-1 flex items-center">
                      <Youtube size={16} className="mr-1 text-primary" /> Futebok
                    </h3>
                    <a 
                      href="https://studio.youtube.com/channel/UCZ0020Iw2UmKGhn_HUDb92w" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-sm text-primary hover:underline"
                    >
                      Visitar Canal
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="destaques" className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {videosDestaque.map((video, index) => (
                <Card key={index} className="overflow-hidden border border-border h-full flex flex-col">
                  <div className="aspect-video overflow-hidden bg-muted">
                    <img 
                      src={video.thumbnail} 
                      alt={video.titulo}
                      className="w-full h-full object-cover transition-transform hover:scale-105"
                    />
                  </div>
                  <CardHeader>
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-xs font-medium bg-primary/10 text-primary px-2 py-1 rounded-full">
                        {video.plataforma}
                      </span>
                      <span className="text-xs text-muted-foreground">
                        {video.canal}
                      </span>
                    </div>
                    <CardTitle className="text-lg">{video.titulo}</CardTitle>
                  </CardHeader>
                  <CardFooter className="mt-auto">
                    <Button 
                      asChild 
                      className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
                    >
                      <a 
                        href={video.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                      >
                        <ExternalLink size={16} className="mr-1" /> Assistir
                      </a>
                    </Button>
                  </CardFooter>
                </Card>
              ))}
            </div>
            
            <div className="bg-muted p-6 rounded-lg mt-8">
              <h2 className="text-xl font-semibold mb-4">Por que acompanhar meus canais?</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-card p-4 rounded-lg border border-border">
                  <h3 className="text-lg font-medium mb-2">Conteúdo Diversificado</h3>
                  <p className="text-sm text-muted-foreground">Canais com diversos temas para todos os gostos: espiritualidade, entretenimento, música e muito mais.</p>
                </div>
                <div className="bg-card p-4 rounded-lg border border-border">
                  <h3 className="text-lg font-medium mb-2">Plataformas Alternativas</h3>
                  <p className="text-sm text-muted-foreground">Presença em plataformas como Rumble, que valorizam a liberdade de expressão e oferecem monetização justa.</p>
                </div>
                <div className="bg-card p-4 rounded-lg border border-border">
                  <h3 className="text-lg font-medium mb-2">Atualizações Regulares</h3>
                  <p className="text-sm text-muted-foreground">Novos vídeos e conteúdos são publicados regularmente para manter você sempre informado e entretido.</p>
                </div>
              </div>
            </div>
          </TabsContent>
        </Tabs>
        
        <div className="text-center mt-8">
          <h2 className="text-2xl font-semibold mb-4">Inscreva-se nos meus canais</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto mb-6">
            Acompanhe todos os meus canais para não perder nenhuma atualização. Seu apoio é fundamental para o crescimento e continuidade dos conteúdos.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Button 
              asChild 
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              <a 
                href="https://rumble.com/c/c-7706553" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Film className="mr-2 h-4 w-4" /> Corte Certo
              </a>
            </Button>
            <Button 
              asChild 
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              <a 
                href="https://rumble.com/c/c-7697051" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Film className="mr-2 h-4 w-4" /> Palavra Viva
              </a>
            </Button>
            <Button 
              asChild 
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              <a 
                href="https://rumble.com/c/c-3001464" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Film className="mr-2 h-4 w-4" /> Canal de Oração
              </a>
            </Button>
            <Button 
              asChild 
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              <a 
                href="https://studio.youtube.com/channel/UCjRjVRJpkKHIrtnBPFS2bfQ" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Youtube className="mr-2 h-4 w-4" /> Trilhos e Trem
              </a>
            </Button>
            <Button 
              asChild 
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              <a 
                href="https://studio.youtube.com/channel/UChR7_LeRtstmwME4uLBjOig" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Youtube className="mr-2 h-4 w-4" /> Sonic Sprount
              </a>
            </Button>
            <Button 
              asChild 
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              <a 
                href="https://www.youtube.com/channel/UCYfW1FfL2OZk5u9-GakVKJg" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Youtube className="mr-2 h-4 w-4" /> CraftyCreations
              </a>
            </Button>
            <Button 
              asChild 
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              <a 
                href="https://studio.youtube.com/channel/UCo-mURMat6Fdqr5X8tZ_v2w" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Youtube className="mr-2 h-4 w-4" /> Planeta Terra Chamando
              </a>
            </Button>
            <Button 
              asChild 
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              <a 
                href="https://rumble.com/c/planetaselvagem6" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Film className="mr-2 h-4 w-4" /> Planeta Selvagem 6
              </a>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MeusCanais;